import app from 'app-entrypoint';

if (typeof app === 'function') {
  app();
}



//////////////////
// WEBPACK FOOTER
// /Users/ryan/Projects/texastribune/candidates-2018/config/entry.js
// module id = null
// module chunks = 